module.exports = __webpack_public_path__ + "media/images/xpass/markers/active-selected/bft-2a2b8faa3f7a61b40084aa567b5fe11b.png";